import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  description: {
    marginBottom: 24,
  },
  field: {
    marginBottom: 24,
  },
  actions: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: 16,
    '@media (max-width: 767px)': {
      flexDirection: "column"
    },
    '& button': {
      width: "100%",
    }
  },
});
